import {Grid, TextField} from '@material-ui/core';
import React, {useEffect, useMemo, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import __ from "lodash";

import {ComboSelect, FlightNumber, FormDialog, MaskedNumber, MaskedText} from "../../../../controls";
import Validator from "../../validators/MultiFlightSelectValidator";
import FlightListLookup from "../../../Flights/components/FlightListLookup";
import FlightsMultiSelect from "../../../Flights/components/FlightsMultiSelect";
import FuelSuppliersAtAirport from "../../../Companies/components/FuelSuppliersAtAirport";


const MultiFlightSelectDialog = (props) => {

  const classes = props.classes;
  const SystemData = props.systemData;
  const formatChars = props.formatChars;
  const airportCode = props.airportCode;
  const fromDate = props.fromDate;
  const orderLines = props.lines
  const preSelection = props.preSelection;

  const queryClient = useQueryClient();
  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    canEdit: false,
    noteUuid: null,
    title: 'Select Flights to add to Order'
  });

  const DisplayForm = () => {

      return (
        <FormDialog
          title={dialogState.title}
          message={preSelection ?  "Confirm flights to add to the Fuel order" : "Select one or more flights to add to the Fuel order"}
          open={dialogState.showDialog}
          record={{airlineCode: "", flightNo: "", fuelPolicy: "SECTOR"}}
          dialogOptions={{width: "xs", maxWidth: "xs", fullWidth: true}}
          classes={classes}
          validator={Validator}
          buttons = {{
            save:{icon: "add_box", key: "Update", label: "Add Flights", color: "primary", disabled: (status)=>{return status.error}},
            cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
          }}
          onChange={(state) => {
            if (state.buttonPressed === "save") {
              const record = state.record;
              const orderLines = [];
              if (record.selectedFlights && Array.isArray(record.selectedFlights)) {
                record.selectedFlights.forEach(flight => {
                  if (preSelection) {
                    const orderLine = {
                      tripLegUuid: flight.tripLegUuid,
                      airlineCode: flight.airlineCode,
                      flightNo: flight.flightNo,
                      flightNumber: flight.airlineCode + flight.flightNo,
                      reference: record.reference|| flight.reference ||`${flight.airlineCode}${flight.flightNo}-${flight.scheduledDepartureTimeUTC}`,
                      aircraftType: "B747F",
                      aircraftTailNumber: flight.aircraftTailNumber || flight.aircraftReg || flight.aircraftId,
                      locationAirportCode: flight.locationAirportCode,
                      arrivalDate: flight.arrivalDate,
                      scheduledArrivalTimeUTC: flight.scheduledArrivalTimeUTC,
                      destinationAirportCode: flight.destinationAirportCode,
                      departureDate: flight.departureDate,
                      scheduledDepartureTimeUTC: flight.scheduledDepartureTimeUTC,
                      volume: record.volume,
                      fuelPolicy: record.fuelPolicy,
                      tankerToLand: record.editTankerToLand ? record.tankerToLand : undefined,
                      fuelSupplierUuid: flight.serviceProviderUuid,
                      companyName: flight.companyName
                    }
                    orderLines.push(orderLine);
                  } else {
                    const orderLine = {
                      tripLegUuid: flight.tripLegUuid,
                      airlineCode: flight.airlineCode,
                      flightNo: flight.flightNo,
                      flightNumber: flight.airlineCode + flight.flightNo,
                      reference: record.reference||`${flight.airlineCode}${flight.flightNo}-${moment.utc(flight.scheduledDepartureTimeUTC).format("MMDD")}`,
                      aircraftType: "B747F",
                      aircraftTailNumber: flight.aircraftTailNumber || flight.aircraftReg || flight.aircraftId,
                      locationAirportCode: flight.originAirportCode,
                      arrivalDate: flight.arrivalDate,
                      scheduledArrivalTimeUTC: flight.arrivalTime,
                      destinationAirportCode: flight.destinationAirportCode,
                      departureDate: moment.utc(flight.scheduledDepartureTimeUTC).format("YYYY-MM-DD"),
                      scheduledDepartureTimeUTC: moment.utc(flight.scheduledDepartureTimeUTC).format("HH:mm"),
                      volume: record.volume,
                      fuelPolicy: record.fuelPolicy,
                      tankerToLand: record.editTankerToLand ? record.tankerToLand : undefined
                    }
                    orderLines.push(orderLine);
                  }
                });

                if (props.onChange) {
                  if (preSelection) {
                    props.onChange(orderLines, record.fuelPolicy);                    
                  } else {
                    props.onChange(orderLines, record.fuelPolicy, record.fuelSupplierUuid, record.supplyDetails);
                  }
                }
                setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
              }
            } else {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            }
          }}
        >
          <Grid container checkChildren={true} spacing={3}>
            {preSelection
              ?
                <></>
              :
                <Grid item xs={12} checkChildren={true}>
                  {(record, changeRecord, changeButtonState)=>
                    <FlightNumber
                      id="flightNumber"
                      label="Filter Flights"
                      mask={"aX-999aa"}
                      code={record.airlineCode}
                      number={record.flightNo}
                      //inputProps={defaultEditProps}
                      onChange={(e, props) => {
                        const data = {
                          ...props.record,
                          airlineCode: e.code,
                          flightNo: e.number,
                          flightNumber: e.code + e.number
                        }
                        props.recordChange(data);
                      }}
                    />
                  }
                </Grid>
            }
            <Grid item xs={6} checkChildren={true}>
              <ComboSelect
                id="fuelPolicy"
                label="Fuel Policy"
                group="FUEL POLICY TYPE"
                subGroup=""
                readOnly={false}
                //style={{marginTop: "1px"}}
                fullWidth
                returnType={"objectOnly"}
                onChange={(returnObject, props) => {
                  if (returnObject && !__.isEmpty(returnObject)) {
                    const editTankerToLand =  returnObject.data?.tankerToLand || false;
                    props.recordChange({...props.record, fuelPolicy: returnObject.code, tankerToLand: editTankerToLand ? 0 : undefined , editTankerToLand});
                  }
                }}
              />
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              {record=>(
                <MaskedNumber
                  id="tankerToLand"
                  label="Land With"
                  style={{ fontSize: "0.875rem", textAlign: "right" }}
                  readOnly={!record.editTankerToLand}
                  decimalScale={1}
                  fixedDecimalScale={true}
                  suffix=" tonnes"
                  valueCap={150}
                  fullWidth
                />
              )}
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              {(record, changeRecord, changeButtonState)=>
                <MaskedNumber
                  id="volume"
                  label="Volume Required"
                  style={{ fontSize: "0.875rem", textAlign: "right" }}
                  readOnly={!dialogState.canEdit}
                  decimalScale={0}
                  fixedDecimalScale={true}
                  suffix=" USG"
                  valueCap={50000}
                  fullWidth
                />
              }
            </Grid>
            <Grid item xs={6} checkChildren={true}>
              {(record, changeRecord, changeButtonState)=>
                <MaskedText
                  id="reference"
                  label="Reference"
                  inputLabelProps={{shrink: true}}
                  mask={"x".repeat(50)}
                  maskChar={""}
                  alwaysShowMask={false}
                  formatChars={formatChars}
                />
              }
            </Grid>
            {preSelection
              ?
                <FuelSuppliersAtAirport
                  airportCode={airportCode}
                  onChange={(fuelSupplier, props) => {
                    if (fuelSupplier.defaultSupplier && fuelSupplier.companyName !== props.record.companyName && fuelSupplier.airportCode !== props.record.airportCode) {
                      const data = {
                        ...props.record,
                        fuelSupplierUuid: fuelSupplier.companyUuid,
                        companyName: fuelSupplier.companyName,
                        supplyDetails: `${fuelSupplier.companyName} (${__.capitalize(fuelSupplier.contractType)}, ${fuelSupplier.pricePeriod})`
                      }
                      props.recordChange(data);
                    }
                  }}
                />
              :
                <></>
            }
            <Grid item xs={12} checkChildren={true}>
              {(record, changeRecord, changeButtonState)=>
                preSelection
                  ?
                    <FlightsMultiSelect
                      id="flightMultiSelect"
                      width={300}
                      classes={classes}
                      canEdit={dialogState.canEdit}
                      airportCode={airportCode}
                      fromDate={fromDate}
                      airlineCode={record.airlineCode}
                      flightNo={record.flightNo}
                      flights={orderLines}
                      onChange={(flights, props)=>{
                        changeRecord({selectedFlights: flights});
                      }}
                    />
                  :
                    <FlightListLookup
                      id="flightListLookup"
                      width={300}
                      classes={classes}
                      canEdit={dialogState.canEdit}
                      airportCode={airportCode}
                      fromDate={fromDate}
                      airlineCode={record.airlineCode}
                      flightNo={record.flightNo}
                      orderLines={orderLines}
                      onChange={(flights, props)=>{
                        changeRecord({selectedFlights: flights});
                      }}
                    />
              }
            </Grid>
          </Grid>
        </FormDialog>
      )
  }

  useEffect(()=> {
    const open = async (params) => {
      //TODO: tripLegUuid should be primaryObjectUuid as it can be either tripLegUuid or tripUuid
      const {title, canEdit} = params;
      setDialogState({...dialogState, showDialog:true, canEdit, title});
    }
    eventBus.bind("FlightListLookup.open", open);
    return () => {
      eventBus.unbind("FlightListLookup.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <DisplayForm />
    )
  }
  return (<></>);
}

export default MultiFlightSelectDialog;
